import { Modal } from '@brighterion/br-ui';
import React, { Dispatch, SetStateAction, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './index.css';

type Props = {
    isOpen: boolean;
    onClose: () => void;
    onContinueWithNavigation: () => void;
    onSaveReport: () => void;
    saveError: boolean;
    saveSuccess: boolean;
    setSaveErrorIsOpen: Dispatch<SetStateAction<boolean>>;
    reportType: ReportType;
};
export const ReportNotSavedWarningModal = ({
    isOpen,
    onClose,
    onContinueWithNavigation,
    onSaveReport,
    saveError,
    saveSuccess,
    setSaveErrorIsOpen,
    reportType
}: Props) => {
    const { t } = useTranslation();

    useEffect(() => {
        if (saveError) {
            setSaveErrorIsOpen(true);
            onClose();
        }
        if (saveSuccess) {
            onContinueWithNavigation();
        }
    }, [onClose, onContinueWithNavigation, saveError, saveSuccess, setSaveErrorIsOpen]);
    return (
        <Modal isOpen={isOpen} closeModal={onClose} status='warning' containerClass={styles.containerClass}>
            <Modal.Title
                id='report-not-saved-modal-title'
                statusIcon='warning'
                title={t('Save Report')}
                onClose={onClose}
                showCloseIcon={false}
            />
            <div className={styles.modalContent}>{t('reportNotSavedWarning', { reportType })}</div>
            <Modal.Footer
                id='report-not-saved-modal-footer'
                onClose={onContinueWithNavigation}
                onCloseText={t('Close Without Saving')}
                onAction={onSaveReport}
                onActionText={t('Save')}
            />
        </Modal>
    );
};
